import React from "react";
import { Navigate } from "react-router-dom";

const StkSaleListComponent = React.lazy(
  () => import("../../../../../components/stk-sale/components/list/page"),
);
const StkSaleAddComponent = React.lazy(
  () => import("../../../../../components/stk-sale/components/add/page"),
);
const StkSaleInvoiceComponent = React.lazy(
  () => import("../../../../../components/stk-sale/components/invoice/page"),
);
const StkSaleShowComponent = React.lazy(
  () => import("../../../../../components/stk-sale/components/show/page"),
);

export const stkSaleRoutes = [
  {
    path: "list",
    element: <StkSaleListComponent />,
  },
  {
    path: "sell",
    element: <StkSaleAddComponent />,
  },
  {
    path: "invoice",
    element: <StkSaleInvoiceComponent />,
  },
  {
    path: "show/:id",
    element: <StkSaleShowComponent />,
  },
  {
    path: "",
    element: <Navigate replace to="/stockify/sales/sell" />,
  },
];
